import { useAccount } from "wagmi";

/**
 * Drop-in replacement for @web3-react/core useWeb3React.
 * chainId comes from useAccount().chainId — this is the wallet's ACTUAL
 * connected chain, not the wagmi config's chain. This ensures the
 * chain-mismatch checks in Banner.js (chainId !== parseInt(CHAIN)) work
 * correctly and trigger a network switch when needed.
 */
export const useWeb3React = () => {
  const { address: account, connector, isConnected, chainId } = useAccount();
  return { account, chainId, connector, isConnected };
};
